import { DataSource, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutSmsMessages extends Layout {
    labelFailed: Label;
    labelFailedCount: Label;
    labelPending: Label;
    labelPendingCount: Label;
    labelTotal: Label;
    labelTotalCount: Label;
    labelUnread: Label;
    labelUnreadCount: Label;
    panelFailed: Panel;
    panelTotal: Panel;
    panelUndelivered: Panel;
    panelUnread: Panel;
    sourceSmsMessages: DataSource;
}
